import React from 'react';
import { Divider, Menu, MenuItem } from '@mui/material';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { Line } from '@paragon/contract-library';

import { showCreateStationDialog, showEditLineDialog } from '../../../actions/dialogActions';
import { deleteLine } from '../../../actions/supervisorActions';
import { useAppDispatch } from '../../hooks';

export function LineMenu(props: {
  line: Line;

  anchor: MenuAnchor;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();

  return (
    <Menu open={props.anchor != null} {...getAnchorProps(props.anchor)} onClose={props.onClose}>
      <MenuItem
        onClick={() => {
          props.onClose();
          dispatch(showEditLineDialog(props.line.guid));
        }}
      >
        Edit line
      </MenuItem>
      <MenuItem
        onClick={() => {
          props.onClose();
          dispatch(deleteLine(props.line.guid));
        }}
      >
        Delete line
      </MenuItem>

      <Divider />

      <MenuItem
        onClick={() => {
          props.onClose();
          dispatch(showCreateStationDialog(props.line.guid));
        }}
      >
        Create station on line
      </MenuItem>
    </Menu>
  );
}
